$(document).ready(function() {

	$(".toggle-product").click(function(e) {
		$(this).parent().toggleClass('active');
	})

	$(".toggle-material").click(function(e) {
		$(this).parent().toggleClass('shown');
	})

	$(".check").click(function(e) {
		$(this).toggleClass('active');
	})






});